export default "__VITE_ASSET__7twltM3y__"